"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCards = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var object_1 = require("../../utils/object");
var guid_1 = require("../../utils/guid");
var parse_json_1 = require("./parse-json");
var removeNullProperties = function (data) {
    return (0, lodash_1.omitBy)(data, lodash_1.isNull);
};
var parseCard = function (itemActionData) {
    var parsedVideoCard = (0, object_1.keysToCamelCase)(itemActionData);
    var type = parsedVideoCard.type, actionId = parsedVideoCard.actionId, clientId = parsedVideoCard.clientId, appearance = parsedVideoCard.appearance, position = parsedVideoCard.position, orientation = parsedVideoCard.orientation, thumbnailUrl = parsedVideoCard.thumbnailUrl;
    var omittedProperties = [
        'actionId',
        'clientId',
        'type',
        'appearance',
        'position',
        'orientation',
        'parentItemId',
        'dateCreated',
        'dateUpdated',
    ];
    var to = appearance ? appearance.start + appearance.duration : undefined;
    var parsedItemAction = tslib_1.__assign({ actionId: actionId, clientId: clientId || (0, guid_1.guid)(), type: type, from: appearance === null || appearance === void 0 ? void 0 : appearance.start, to: to, position: position, orientation: orientation, file: thumbnailUrl }, (0, lodash_1.omit)(parsedVideoCard, omittedProperties));
    return (0, lodash_1.flow)(removeNullProperties, parse_json_1.parseJSON)(parsedItemAction);
};
var parseCards = function (rawCards) {
    var videoCards = (0, lodash_1.map)(rawCards, parseCard);
    return (0, lodash_1.orderBy)(videoCards, ['from', 'updatedTimestamp'], ['asc', 'asc']);
};
exports.parseCards = parseCards;
//# sourceMappingURL=cards.js.map